// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.first-col[data-v-f1ad1b58] {\r\n  display: inline-block;\n}\n.first-col-bottom[data-v-f1ad1b58] {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 10px;\r\n  right: 10px;\r\n  padding-bottom: 10px;\n}\n.first-col-content[data-v-f1ad1b58] {\r\n  display: inline-block;\r\n  height: 20px;\r\n  line-height: 20px;\r\n  border: 1px red solid;\n}\n.custom-title[data-v-f1ad1b58] {\r\n  /* overflow: hidden; */\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\n}\r\n", ""]);
// Exports
module.exports = exports;
